"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetCollectionItemImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing AssetCollectionItem operations. */
var AssetCollectionItemImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class AssetCollectionItem class.
   * @param client Reference to the service client
   */
  function AssetCollectionItemImpl(client) {
    (0, _classCallCheck2["default"])(this, AssetCollectionItemImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
   * @param portalId (Access Controlled)
   * @param assetCollectionId (Access Controlled)
   * @param nodeId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(AssetCollectionItemImpl, [{
    key: "getNode",
    value: function getNode(portalId, assetCollectionId, nodeId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        nodeId: nodeId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getNodeOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getNodes",
    value: function getNodes(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getNodesOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param nodeId
     * @param options The options parameters.
     */

  }, {
    key: "deleteNode",
    value: function deleteNode(portalId, assetCollectionId, nodeId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        nodeId: nodeId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteNodeOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param nodeId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "updateNode",
    value: function updateNode(portalId, assetCollectionId, nodeId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        nodeId: nodeId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, updateNodeOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param folderId
     * @param index
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "addNodeToFolder",
    value: function addNodeToFolder(portalId, assetCollectionId, folderId, index, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        folderId: folderId,
        index: index,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, addNodeToFolderOperationSpec);
    }
  }]);
  return AssetCollectionItemImpl;
}(); // Operation Specifications


exports.AssetCollectionItemImpl = AssetCollectionItemImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getNodeOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Node({nodeId})",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.NodeInfo
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.nodeId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getNodesOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Nodes",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NodeInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var deleteNodeOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Nodes({nodeId})",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.nodeId],
  serializer: serializer
};
var updateNodeOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Nodes({nodeId})",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.NodeInfo
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body14,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.nodeId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var addNodeToFolderOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Nodes({folderId})/ChildNodes({index})",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.NodeInfo
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body14,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.index, Parameters.folderId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};